import React from 'react';

const ConnectionCount = ({ connections, className = '' }) => {
  if (!connections) return null;
  const { vnc = 0, ssh = 0, websockets = null } = connections;
  const parts = [];
  if (vnc > 0) parts.push({ key: 'vnc', label: `${vnc} VNC`, live: true });
  if (ssh > 0) parts.push({ key: 'ssh', label: `${ssh} SSH`, live: true });
  if (typeof websockets === 'number') parts.push({ key: 'ws', label: `${websockets} WS`, live: false });
  if (parts.length === 0) return null;

  const title =
    `${vnc} VNC viewer${vnc === 1 ? '' : 's'}, ${ssh} SSH terminal${ssh === 1 ? '' : 's'} open through the dashboard` +
    (typeof websockets === 'number'
      ? `; ${websockets} websocket client${websockets === 1 ? '' : 's'} reported by the devkit`
      : '');

  return (
    <span
      className={`text-xs font-normal text-gray-400 tabular-nums whitespace-nowrap ${className}`}
      title={title}
    >
      {parts.map((p, i) => (
        <React.Fragment key={p.key}>
          {i > 0 && <span className="mx-1 text-gray-300">·</span>}
          <span className={p.live ? 'text-sky-600' : ''}>{p.label}</span>
        </React.Fragment>
      ))}
    </span>
  );
};

export default ConnectionCount;
